export const PROJECTED_SITES_MANAGER_SEAWATER_FILTERS = [
  {
    id: 1,
    name: 'Client Name',
    label: 'client_name',
    storeName: 'client',
    translateName: 'clientName',
    filterType: 'clients',
    value: [],
    data: [],
  },
  {
    id: 2,
    name: 'Site-SIEP',
    label: 'site_siep',
    storeName: 'site',
    translateName: 'siteSIEP',
    filterType: 'sites',
    value: [],
    data: [],
  },
  {
    id: 3,
    name: 'Region',
    label: 'region',
    storeName: 'region',
    translateName: 'region',
    filterType: 'regions',
    value: [],
    data: [],
  },
  {
    id: 4,
    name: 'Specie',
    label: 'specie',
    storeName: 'specie',
    translateName: 'specie',
    filterType: 'species',
    value: [],
    data: [],
  },
]

export const PROJECTED_SITES_MANAGER_FRESHWATER_FILTERS = [
  {
    id: 1,
    name: 'Client Name',
    label: 'client_name',
    storeName: 'clientName',
    translateName: 'clientName',
    filterType: 'clients',
    value: [],
    data: [],
  },
]

export const SEAWATER_SITE_LIST_FIELDS = [
  {
    id: 1,
    name: 'Client Name',
    storeName: 'client',
    translateName: 'clientName',
    type: 'client',
  },
  {
    id: 2,
    name: 'Site-SIEP',
    storeName: 'site',
    translateName: 'siteSIEP',
    type: 'site',
  },
  {
    id: 3,
    name: 'Specie',
    storeName: 'specie',
    translateName: 'specie',
    type: 'specie',
  },
  {
    id: 4,
    name: 'Year class',
    storeName: 'yearClass',
    translateName: 'yearClass',
    type: 'yearClass',
  },
  {
    id: 5,
    name: 'Stocking Month-Year',
    storeName: 'stockingMonthYear',
    translateName: 'stockingMonthYear',
    type: 'stockingMonthYear',
  },
  {
    id: 6,
    name: 'Stocking Fish Count',
    storeName: 'stockingFishCount',
    translateName: 'stockingFishCount',
    type: 'stockingFishCount',
  },
  {
    id: 7,
    name: 'Stocking weight',
    storeName: 'stockingWeight',
    translateName: 'stockingWeight',
    type: 'stockingWeight',
  },
  {
    id: 8,
    name: 'Number of Farming Month',
    storeName: 'monthsFromStocking',
    translateName: 'monthsFromStocking',
    type: 'monthsFromStocking',
  },
  {
    id: 9,
    name: 'Expected Number of Cages',
    storeName: 'numberOfCages',
    translateName: 'numberOfCages',
    type: 'numberOfCages',
  },
  {
    id: 10,
    name: 'Harvesting Month-Year',
    storeName: 'harvestingMonthYear',
    translateName: 'harvestingMonthYear',
    type: 'harvestingMonthYear',
  },
  {
    id: 11,
    name: 'Harvesting length in months',
    storeName: 'harvestingLength',
    translateName: 'harvestingLength',
    type: 'harvestingLength',
  },
  {
    id: 12,
    name: 'Diet strategy',
    storeName: 'productFamilyName',
    translateName: 'productFamilyName',
    type: 'productFamilyName',
  },
]

export const FRESHWATER_FIELDS = [
  {
    id: 1,
    name: 'Client Name',
    storeName: 'clientName',
    translateName: 'clientName',
    type: 'clientName',
  },
]

export const FRESHWATER_CLIENT_FEILDS = [
  {
    id: 1,
    name: 'Month-Year',
    storeName: 'monthYear',
    translateName: 'monthYear',
    type: 'monthYear',
  },
  {
    id: 2,
    name: 'Ecto predicted base product',
    storeName: 'predictionBaseProduct',
    translateName: 'predictionBaseProduct',
    type: 'predictionBaseProduct',
  },
  {
    id: 3,
    name: 'Ecto predicted base product sales',
    storeName: 'predictedSales',
    translateName: 'predictedSales',
    type: 'predictedSales',
  },
  {
    id: 4,
    name: 'Product family',
    storeName: 'userProjectedProductFamily',
    translateName: 'userProjectedProductFamily',
    type: 'userProjectedProductFamily',
  },
  {
    id: 5,
    name: 'Diet Group',
    storeName: 'userProjectedDietGroup',
    translateName: 'userProjectedDietGroup',
    type: 'userProjectedDietGroup',
  },
  {
    id: 6,
    name: 'Hist.AT',
    storeName: 'userProjectedHistidine',
    translateName: 'userProjectedHistidine',
    type: 'userProjectedHistidine',
  },
  // {
  //   id: 7,
  //   name: 'Product',
  //   storeName: 'userProjectedProduct',
  //   translateName: 'userProjectedProduct',
  //   type: 'userProjectedBaseProduct',
  // },
  {
    id: 8,
    name: 'Pigment',
    storeName: 'userProjectedPigment2',
    translateName: 'userProjectedPigment',
    type: 'userProjectedPigment2',
  },
  {
    id: 9,
    name: 'BioMar Additives',
    storeName: 'userProjectedAdditives2',
    translateName: 'userProjectedAdditives',
    type: 'userProjectedAdditives2',
  },
  {
    id: 10,
    name: 'Projected sales',
    storeName: 'userProjectedSales',
    translateName: 'userProjectedSales',
    type: 'userProjectedSales',
  },
  {
    id: 11,
    name: 'Reason',
    storeName: 'reason',
    translateName: 'reason',
    type: 'reason',
  },
]

export const SEAWATER_SITE_FIELDS = [
  {
    id: 1,
    name: 'Month-Year',
    storeName: 'monthYear',
    translateName: 'monthYear',
    type: 'monthYear',
  },
  {
    id: 2,
    name: 'SKU ECTO',
    storeName: 'sku',
    translateName: 'skuEcto',
    type: 'sku',
  },
  {
    id: 3,
    name: 'Product family',
    storeName: 'userProjectedProductFamily',
    translateName: 'userProjectedProductFamily',
    type: 'userProjectedProductFamily',
  },
  {
    id: 4,
    name: 'Diet Group',
    storeName: 'userProjectedDietGroup',
    translateName: 'userProjectedDietGroup',
    type: 'userProjectedDietGroup',
  },
  {
    id: 5,
    name: 'Hist.AT',
    storeName: 'userProjectedHistidine',
    translateName: 'userProjectedHistidine',
    type: 'userProjectedHistidine',
  },
  // {
  //   id: 6,
  //   name: 'Product',
  //   storeName: 'userProjectedProduct',
  //   translateName: 'userProjectedProduct',
  //   type: 'userProjectedBaseProduct',
  // },
  {
    id: 7,
    name: 'Pigment',
    storeName: 'userProjectedPigment2',
    translateName: 'userProjectedPigment',
    type: 'userProjectedPigment2',
  },
  {
    id: 8,
    name: 'BioMar Additives',
    storeName: 'userProjectedAdditives2',
    translateName: 'userProjectedAdditives',
    type: 'userProjectedAdditives2',
  },
  {
    id: 9,
    name: 'Predicted feed consumption',
    storeName: 'predictedFeedConsumption',
    translateName: 'predictedFeedConsumption',
    type: 'predictedFeedConsumption',
  },
  {
    id: 10,
    name: 'Projected feed consumption',
    storeName: 'userProjectedFeedConsumption',
    translateName: 'userProjectedFeedConsumption',
    type: 'userProjectedFeedConsumption',
  },
  {
    id: 11,
    name: 'Predicted sales',
    storeName: 'predictedSales',
    translateName: 'predictedSales',
    type: 'predictedSales',
  },
  {
    id: 12,
    name: 'Projected sales',
    storeName: 'userProjectedSales',
    translateName: 'userProjectedSales',
    type: 'userProjectedSales',
  },
  {
    id: 13,
    name: 'Reason',
    storeName: 'reason',
    translateName: 'reason',
    type: 'reason',
  },
]

export const SEAWATER_SITE_REASONS = [
  'harvest_advance',
  'stocking_advance',
  'adjustment_for_recent_stocking',
  'sea_wolf_attack',
  'increased_consumption_higher_t',
  'increased_consumption_post_selection_of_fish',
  'increased_consumption_post_medication',
  'reason_low_oxygen',
  'algae_bloom',
  'assignment_changed_by_client',
  'supplier_change_due_to_customer_complaint',
  'plant_capacity',
  'newly_assigned_site',
  'sovereignty_site',
  'spot_site',
  'food_consumption_in_stock',
  'food_consumption_stock',
  'contract_tender_scenario',
  'sinister',
  'compensatory_growth',
  'purchase_order_offset',
  'returned_food',
  'photoperiod_effect',
  'sanitary_status',
  'functional_competence',
  'medicated_admission_without_discounting',
  'fish_manager',
  'safeguard_stock_management',
  'medicated_competitior',
  'improves_feeding_after_low_o2_or_bloom',
  'new_biomar_allocation',
  'truckers_strike',
  'retargeting_customer',
  'productive_restriction',
  'harvest_delay',
  'logistics_delay',
  'fish_stock_delay',
  'without_major_difference',
  'overestimation_of_internal_projection_consumption',
  'underestimation_of_projected_consumption',
  'early_sale',
  'cancellation_by_biomar_request',
  'reason_low_transparency',
  'lower_consumption_environmental_issues',
]

export const FRESHWATER_CLIENT_REASONS = [
  'low_inventory',
  'maintenance',
  'changes_in_contract',
  'slowdown_feeding_because_of_external_reasons',
]

export const CLIENT_STORE_NAME = 'client'
export const SITE_STORE_NAME = 'site'
export const REGION_STORE_NAME = 'region'
export const SPECIE_STORE_NAME = 'specie'
